/**
 * toTitleCase()
 *
 * Converts a string to title case, capitalizing the first letter of each word.
 *
 * @param {string} str - The input string to be converted to title case.
 * @returns {string} The converted string in title case.
 * @example
 * const text = "this is a sample text";
 * const titleCaseText = toTitleCase(text);
 * console.log(titleCaseText); // "This Is A Sample Text"
 */

export function toTitleCase(str) {
    return str
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
}
